/**
 * Global dashboard availability, independent of account permissions.
 * Keep disabled features' data and implementation for deliberate reactivation.
 * Backend guards are authoritative; these switches prevent UI entry/loading.
 */
export const FEATURE_AVAILABILITY: Record<
  "genetik" | "repro" | "businessModelCalculator",
  boolean
> = {
  genetik: false,
  repro: false,
  businessModelCalculator: false,
};

export function isFeatureAvailable(
  feature: keyof typeof FEATURE_AVAILABILITY,
): boolean {
  return FEATURE_AVAILABILITY[feature];
}